import { render, staticRenderFns } from "./AdminPackages.vue?vue&type=template&id=24b4e822&scoped=true"
import script from "./AdminPackages.vue?vue&type=script&lang=js"
export * from "./AdminPackages.vue?vue&type=script&lang=js"
import style0 from "./AdminPackages.vue?vue&type=style&index=0&id=24b4e822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b4e822",
  null
  
)

export default component.exports